import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import {ActivatedRoute, ROUTER_DIRECTIVES} from "@angular/router";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    FormControl,
    FormGroup,
    REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {AlertComponent} from "ng2-bootstrap/ng2-bootstrap";
import {
    DATE_VALID_CHARACTERS,
    DATE_VALIDATOR,
    DEFAULT_ERROR_MESSAGES,
    FILE_MAX_SIZE,
    IsExpirated
} from "../validators/validators";
import {LoginService} from "../service/login.service";
import {Vehicle} from "../domain/vehicle";
import {Router, ROUTER_PROVIDERS} from "@angular/router-deprecated";
import {PatentPaymentService} from "../service/patentPayment.service";
import {Procedure} from "../domain/procedure";
import {ExpirationType} from "../domain/expirationType";
import {Observable} from "rxjs/Observable";
import {ProcedureService} from "../service/procedure.service";
import {FILE_UPLOAD_DIRECTIVES, FileUploader} from "ng2-file-upload";
import {ProcedureType} from "../domain/procedureType";
import {ProcedureDocument} from "../domain/ProcedureDocument";
import {AddPatentPayment} from "../domain/AddPatentPayment";

@Component({
    selector: 'patentPayment-editor',
    template: require('./patentPayment.editor.component.html'),
    styles: [require('./patentPayment.editor.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        ROUTER_DIRECTIVES,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS, ROUTER_PROVIDERS],
    pipes: [
        IsExpirated
    ]
})
export class PatentPaymentEditorComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() vehicle: Vehicle;
    @Output() close = new EventEmitter();

    private sub: any;

    public errorMessages: any;
    public form: FormGroup;

    private vehicleId: string;

    public errorMessage: string;
    public successMessage: string;
    public warningMessage: string;

    public newPatentPayment: Procedure;

    private patentPaymentType: ProcedureType;

    public expirationsType: ExpirationType[];

    public expirationTypeUnique: ExpirationType;

    public expirationTypeUniqueStr: string;

    public expirationTypeSelectedId: string;

    public loading: boolean;

    public canEdit: boolean;

    private todayStr: string;

    public uploaderDocument: FileUploader;
    public hasDocumentDropZoneOver: boolean;

    @ViewChild('inputDocument') inputAct: ElementRef;

    public isUploading: boolean;

    constructor(private router: Router,
                private patentPaymentService: PatentPaymentService,
                private procedureService: ProcedureService,
                private route: ActivatedRoute,
                private loginService: LoginService) {

        this.procedureService.getProcedureType('LICENSE_PLATE').subscribe(
            this.setProcedureType.bind(this),
            () => {
                this.bindError('Ocurrió un error al buscar el tipo de trámite.');
            });

        this.init();
    }

    private init(): void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.newPatentPayment = new Procedure();

        this.loading = false;

        this.canEdit = false;

        let dateStrParts = new Date();
        this.todayStr = this.padLeft(dateStrParts.getDate().toString(), '0', 2) + '/' +
            this.padLeft((dateStrParts.getMonth() + 1).toString(), '0', 2) + '/' + dateStrParts.getFullYear();


        this.newPatentPayment.customDate = this.todayStr;

        this.vehicle = new Vehicle();

        this.uploaderDocument = new FileUploader({});
        this.hasDocumentDropZoneOver = false;

        this.isUploading = false;

        this.expirationTypeUniqueStr = 'UNIQUE';
    }

    private padLeft(text: string, padChar: string, size: number): string {
        return (String(padChar).repeat(size) + text).substr((size * -1), size);
    }

    private createFormGroup(): void {
        this.form = new FormGroup({
            type: new FormControl(this.vehicle.type.description),
            patent: new FormControl(this.vehicle.patent),
            brand: new FormControl(this.vehicle.brand.name),
            model: new FormControl(this.vehicle.model),
            year: new FormControl(this.vehicle.year),
            engineNumber: new FormControl(this.vehicle.engineNumber),
            newPatentPaymentDescription: new FormControl(this.newPatentPayment.description),
            newPatentPaymentExpirationType: new FormControl(this.newPatentPayment.expirationType, [Validators.required]),
            newPatentPaymentCustomDate: new FormControl(this.newPatentPayment.customDate, [Validators.required, DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
            newPatentPaymentSolicitudeDate: new FormControl(this.newPatentPayment.patentPayment.solicitudeDate, [Validators.required, DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
            newPatentPaymentSolicitudePerson: new FormControl(this.newPatentPayment.patentPayment.solicitudePerson, [Validators.required])
        });
    }

    public ngOnInit() {
        let userLogged = this.loginService.getUserLogged();
        this.canEdit = userLogged.isActionAllowed('PATENT_PAYMENT', 'EDIT', 'PATENT_PAYMENT');

        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            this.vehicleId = params['vehicleId'];
            this.getData();
        });
    }

    public ngAfterViewInit() {
    }

    private getData(): void {
        this.loading = true;
        this.errorMessage = null;

        let forkTasks: Observable<any>[] = [];
        forkTasks.push(this.procedureService.getExpirationTypes());
        forkTasks.push(this.patentPaymentService.getVehicle(this.vehicleId));
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los datos de patentes.');
            });
    }

    private setData(data: any[]): void {
        this.loading = false;
        this.expirationsType = data[0];
        this.expirationTypeUnique = this.expirationsType.filter(expirationType => expirationType.id == (1).toString())[0];
        this.vehicle = data[data.length - 1];

        this.expirationTypeSelectedId = null;
        if (this.expirationsType.length > 0) {
            this.newPatentPayment.expirationType = this.expirationsType[0];
            this.expirationTypeSelectedId = this.expirationsType[0].id;
        }
        this.newPatentPayment.type = this.patentPaymentType;

        this.updateUploaderUrl();

        this.procedureService.generateProcedureTempId()
            .subscribe(
                (response) => {
                    this.newPatentPayment.tempId = response.value;
                    this.updateUploaderUrl();
                },
                () => {
                    this.bindError('Ocurrió un error al generar una patente.');
                });
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.errorMessage = null;
        this.warningMessage = null;
    }

    public save(): void {
        this.clearMessages();
        this.isUploadingAFile();
        if (!this.checkAllBeforeSave()) {
            this.loading = true;

            this.patentPaymentService.save(this.vehicle).subscribe(
                (saved: Vehicle) => {
                    this.loading = false;
                    this.vehicle = saved;
                    this.successMessage = 'La carga de patente se guardó con éxito';
                    this.updateViewAfterSave();

                    if (this.checkPreSavePatentPayments()) {
                        this.bindWarning('Existen Históricos de kilómetros sin guardar.');
                    }
                },
                () => {
                    this.bindError('Ocurrió un error al guardar la información.');
                });
        } else {
            this.bindError('Existe un archivo pendiente de subida. Recuerde que el tamaño máximo del archivo a subir es de 10Mb.');
        }
    }

    public goBack(event: any): void {
        event.preventDefault();
        this.close.emit(this.vehicle);
        window.history.back();
    }

    private addNewPatentPaymentToVehicle(): void {
        this.uploaderDocument.queue.forEach((item) => {
            this.newPatentPayment.document = new ProcedureDocument();
            this.newPatentPayment.document.id = "temp/" + this.newPatentPayment.tempId;
            this.newPatentPayment.document.name = item.file.name;
        });

        this.vehicle.procedures.push((JSON.parse(JSON.stringify(this.newPatentPayment))));
        this.newPatentPayment = new Procedure();
        this.newPatentPayment.customDate = this.todayStr;
        this.newPatentPayment.type = this.patentPaymentType;
        this.newPatentPayment.patentPayment = new AddPatentPayment();
        if (this.expirationsType.length > 0) {
            this.newPatentPayment.expirationType = this.expirationsType[0];
            this.expirationTypeSelectedId = this.expirationsType[0].id;
        }

        this.procedureService.generateProcedureTempId()
            .subscribe(
                (response) => {
                    this.newPatentPayment.tempId = response.value;
                    this.updateUploaderUrl();
                },
                () => {
                    this.bindError('Ocurrió un error al generar una patente.');
                });

        this.uploaderDocument.clearQueue();
    }

    public addNewPatentPayment(event: any): void {
        event.preventDefault();
        this.addNewPatentPaymentToVehicle();

        this.clearMessages();
        this.bindWarning('Existen Pago de Patentes sin guardar.');
    }

    public deletePatentPayment(event: any, index: number, id: string, idTemp: string): void {
        event.preventDefault();

        this.clearMessages();
        this.loading = true;

        let notPending = false;
        if (id != undefined && id != null) {
            notPending = true;
            this.patentPaymentService.delete(id).subscribe(
                () => {
                    this.loading = false;
                    this.successMessage = 'La carga de patente se eliminó con éxito';

                    this.loading = false;
                    this.vehicle.procedures.splice(index, 1);

                    if (this.checkPreSavePatentPayments()) {
                        this.clearMessages();
                        this.bindWarning('Existen Pago de Patentes sin guardar.');
                    }
                },
                () => {
                    this.bindError('Ocurrió un error al eliminar la patente.');
                });
        }
        if (idTemp != undefined && idTemp != null) {
            notPending = true;
            this.procedureService.deleteTempProcedureDocument(idTemp).subscribe(
                () => {
                    this.loading = false;
                    this.successMessage = 'La carga de patente se eliminó con éxito';

                    this.loading = false;
                    this.vehicle.procedures.splice(index, 1);

                    if (this.checkPreSavePatentPayments()) {
                        this.clearMessages();
                        this.bindWarning('Existen Pago de Patentes sin guardar.');
                    }
                },
                () => {
                    this.bindError('Ocurrió un error al eliminar la patente.');
                });
        }

        if (!notPending) {
            this.loading = false;
            this.vehicle.procedures.splice(index, 1);

            if (this.checkPreSavePatentPayments()) {
                this.bindWarning('Existen Pago de patentes sin guardar.');
            }
        }
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }

    private bindWarning(messageWarning: string): void {
        this.loading = false;
        if (this.warningMessage == null) {
            this.warningMessage = messageWarning;
        } else {
            this.warningMessage = this.warningMessage.toString() + ' ' + messageWarning;
        }
    }

    public expirationTypeChange(newValue: any): void {
        let result = this.expirationsType.filter(function (obj: ExpirationType) {
            return obj.id == newValue;
        });
        if (result.length > 0) {
            this.newPatentPayment.expirationType = result[0];
        }

        if (this.isUniqueExpirationDate()) {
            this.newPatentPayment.customDate = null;
        } else {
            this.newPatentPayment.customDate = this.todayStr;
        }
    }

    public isUniqueExpirationDate(): boolean {
        return this.newPatentPayment.expirationType.id !== this.expirationTypeUnique.id
    }

    public removeDocument(): void {
        this.newPatentPayment.document = null;
    }

    private updateUploaderUrl(): void {
        let fileOwnerId = this.newPatentPayment.tempId;
        this.uploaderDocument = new FileUploader({
            url: 'procedure/' + fileOwnerId + '/upload',
            autoUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        });
    }

    public isUploadingAFile() {
        this.isUploading = this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderDocument.queue && this.uploaderDocument.queue.length == 0;
    }

    public fileOverDocument(e: any): void {
        this.hasDocumentDropZoneOver = e;
    }

    public removeDocumentFromQuee(item: any): void {
        this.procedureService.deleteTempProcedureDocument(this.newPatentPayment.tempId).subscribe(
            (result) => item.remove(),
            () => {
                this.bindError('Ocurrió un error al eliminar el documento de patente.');
            });
    }

    private checkAllBeforeSave() {
        return this.isUploading || this.loading || this.uploaderDocument.isUploading;
    }

    private updateViewAfterSave(): void {
        this.uploaderDocument.clearQueue();
        this.vehicle.procedures.forEach((procedure, index) => {
            if (procedure.id == undefined || procedure.id == null) {
                this.vehicle.procedures.splice(index, 1);
            }
        });
    }

    private setProcedureType(patentPayment: ProcedureType): void {
        this.patentPaymentType = patentPayment;
    }

    public checkIfNotValid(): boolean {
        if (!this.form.controls["newPatentPaymentCustomDate"].valid &&
            this.newPatentPayment.expirationType.id === this.expirationTypeUnique.id) {
            return true;
        }
        /*!this.form.valid ||*/
        return this.loading || this.uploaderDocument.isUploading || this.uploaderDocument.queue.length == 0;
    }

    private checkPreSavePatentPayments(): boolean {
        let hasPreSavePatentPayments = false;
        this.vehicle.procedures.forEach(patentPayment => {
            if (patentPayment.id === undefined || patentPayment.id === null) {
                hasPreSavePatentPayments = true;
            }
        });
        return hasPreSavePatentPayments;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/patentPayment/patentPayment.editor.component.ts
 **/